import styled from 'styled-components'

import { theme } from '../../../styles/theme'

import checked from '../../../assets/png/checked.png'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    transform: scale(1.005);

    transition: transform 0.2s;
  }

  input {
    width: 20px;
    height: 20px;

    border: 1px solid ${theme.colors.gray400};

    appearance: none;

    &:checked {
      border-color: ${theme.colors.green1};

      &::before {
        content: '';
        display: block;
        width: 18px;
        height: 18px;
        background: url(${checked}) no-repeat center center;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  label {
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.gray900};

    &[aria-checked='true'] {
      font-weight: ${theme.font.bold};
    }

    &:hover {
      cursor: pointer;
    }
  }
`
